import { DocumentNode, gql } from '@apollo/client';
import { TablesDisplayGridRowDataFragmentGql } from './TablesDisplayGridRowDataFragmentGql';
import { TagsFragmentGql } from './TagsFragment';

export const TablesByTagQueryGql: DocumentNode = gql`
query TablesByTag(
  $tagName: String!,
  $first: Int!,
  $offset: Int!,
  $textSearch: String,
  $orderBy: DatabaseTableSortOrder!,
  $hasActiveWarning: Boolean,
  $isCertified: Boolean,
  
) {
  tags(filter: {name: $tagName}) {
    databaseTablesConnection(
      first: $first,
      offset: $offset,
      orderBy: $orderBy,
      filter: {
        hasActiveWarning: $hasActiveWarning,
        isCertified: $isCertified,
        text: $textSearch
      },
      permissionMode: FILTER_RESULTS
    ) {
      totalCount
      nodes {
        ...TablesDisplayGridRowData
        ...Tags
      }
    }
    maxDownstreamDatasources: databaseTablesConnection(
      filter: {
        hasActiveWarning: $hasActiveWarning,
        isCertified: $isCertified,
        text: $textSearch
      }
      orderBy: { field: DOWNSTREAM_DATASOURCES_COUNT, direction: DESC }
      first: 1,
      permissionMode: FILTER_RESULTS
    ) {
      nodes {
        downstreamDatasourcesConnection { totalCount }
      }
    }
    maxDownstreamWorkbooks: databaseTablesConnection(
      filter: {
        hasActiveWarning: $hasActiveWarning,
        isCertified: $isCertified,
        text: $textSearch
      }
      orderBy: { field: DOWNSTREAM_WORKBOOKS_COUNT, direction: DESC }
      first: 1,
      permissionMode: FILTER_RESULTS
    ) {
      nodes {
        downstreamWorkbooksConnection { totalCount }
      }
    }
  }
}
${TagsFragmentGql}
${TablesDisplayGridRowDataFragmentGql}
`;
